import { ColumnSizing } from '../tables-context';
import { MRT_ColumnDef } from 'material-react-table';
import { IAgency } from '../../../constants/new-agency/new-agency-form';
import { TableCell } from '../../../components/table/TableCell';
import React from 'react';

export enum SalesAgenciesTableAccessorKeys {
  name = 'name',
}

export const defaultSalesAgenciesColumnSizing: ColumnSizing = {
  [SalesAgenciesTableAccessorKeys.name]: 100,
};

export const defaultSalesAgenciesColumns: MRT_ColumnDef<IAgency>[] = [
  {
    accessorKey: SalesAgenciesTableAccessorKeys.name,
    header: 'Name',
    enableSorting: false,
    Header: <span className="text-muted fw-bolder main-font-family">File name</span>,
    Cell: ({ renderedCellValue, table }: any): JSX.Element => (
      <TableCell
        additionalClass="main-font-family text-black fs-7"
        density={table?.options?.state?.density}
        isTextOverflow={false}
      >
        {renderedCellValue ? renderedCellValue : '-'}
      </TableCell>
    )
  },
];